import $ from 'jquery';

(() => {

  const contents = '_anchorscroll';

  $(function(){

    // $('.np__pagetop')

    var appear = false;
    var pagetop = $('.np__pagetop');
    $(window).scroll(function() {
        if ($(this).scrollTop() > 300) {
            if (appear == false) {
                appear = true;
                pagetop.stop().animate({
                    'bottom': '40px'
                }, 300);
            }

        } else {
            if (appear) {
                appear = false;
                pagetop.stop().animate({
                    'bottom': '-100px'
                }, 300);
            }
        }
    });

    // smoothスクロールがテーマスクリプトにて実装あり

    // $('a[href^="#"]').on('click',function(e){
    //   var minus = 0;
    //   var speed = 1000;
    //   var href= $(this).attr("href");
    //   var target = $(href == "#" || href == "" ? 'html' : href);
    //   if(target.length){
    //     console.log("fire _anchorscroll");
    //     e.stopPropagation();
    //     e.preventDefault();
    //     var position = target.offset().top - 60;
    //     $("html, body").animate({scrollTop:position}, speed, "swing");
    //     return false;
    //   }
    // });
  });

})();
